import { Palmtree } from "lucide-react";
import { useTranslation } from "react-i18next";

import type { Vacation } from "@/api/queries";
import { Badge } from "@/components/ui/badge";
import { formatDayMonth } from "@/lib/format";
import { cn } from "@/lib/utils";

type VacationBadgeProps = {
  vacation: Vacation | undefined;
  /** Also show a planned vacation ("from 20 Sep"). */
  upcoming?: boolean;
  className?: string;
};

/** "On vacation until 23 Sep" next to a person's name. */
export function VacationBadge({ vacation, upcoming, className }: VacationBadgeProps) {
  const { t, i18n } = useTranslation();
  const lang = i18n.resolvedLanguage ?? "ru";
  if (!vacation || (!vacation.active && !upcoming)) return null;
  const text = vacation.active
    ? vacation.until
      ? t("vacations.badgeUntil", { date: formatDayMonth(vacation.until, lang) })
      : t("vacations.badge")
    : t("vacations.badgeFrom", { date: formatDayMonth(vacation.from, lang) });
  return (
    <Badge variant={vacation.active ? "primary" : "neutral"} className={cn("shrink-0", className)}>
      <Palmtree className="size-3" aria-hidden="true" />
      {text}
    </Badge>
  );
}
